import { Button, CircularProgress, Typography } from '@mui/material';
import { BaseDialog } from '../common';

type ConfirmDialogProps = {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  confirmColor?: 'error' | 'primary';
  processing?: boolean;
  errorMessage?: string | null;
  disableClose?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const ConfirmDialog = ({
  open,
  title,
  description,
  confirmLabel,
  confirmColor = 'primary',
  processing = false,
  errorMessage = null,
  disableClose = false,
  onClose,
  onConfirm,
}: ConfirmDialogProps) => (
  <BaseDialog
    open={open}
    onClose={() => {
      if (!disableClose) {
        onClose();
      }
    }}
    title={title}
    actions={
      <>
        <Button onClick={onClose} disabled={processing || disableClose}>
          Cancel
        </Button>
        <Button
          color={confirmColor}
          variant="contained"
          onClick={onConfirm}
          disabled={processing}
          startIcon={processing ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          {confirmLabel}
        </Button>
      </>
    }
  >
    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
      {description}
    </Typography>
    {errorMessage && (
      <Typography variant="body2" color="error.main" sx={{ mt: 1 }}>
        {errorMessage}
      </Typography>
    )}
  </BaseDialog>
);
